
import {
  Quote,
  QuoteRequestType,
} from "functions/src/Payments/PaymentsInterfaces";
import { QuoteSubscriptionRequest } from "functions/src/Subscriptions/SubscriptionsInterfaces";
import { defineComponent } from "vue";
import { CheckoutModal } from "../components/modals";
import { mapGetters } from "vuex";
import { SearchUsers } from "../components";
import RegisterCard from "../components/subscriptions/RegisterCard.vue";
import { quoteSubscription } from "@/store/Subscriptions/SubscriptionsConsts";
import * as bs from "bootstrap";

export default defineComponent({
  name: "tools",
  components: {
    searchUser: SearchUsers.SearchUser,
    RegisterCard,
    CheckoutModal,
  },
  data() {
    return {
      quote: {} as Quote<QuoteRequestType>,
      affiliateIsPaid: false,
      isQuoting: false,
      modalObj: {} as any,
    };
  },
  computed: {
    ...mapGetters("sys", ["isOffline"]),
    ...mapGetters("subs", ["isUserActive", "isUserDistributor"]),
    isActive(): boolean {
      return this.isUserActive && this.isUserDistributor;
    },
  },
  methods: {
    clearQuote() {
      this.quote = {} as Quote<QuoteRequestType>;
    },
    createQuote(request: QuoteSubscriptionRequest): void {
      if (!this.isOffline) {
        this.isQuoting = true;
        this.$store.dispatch("subs/" + quoteSubscription, request).then((q) => {
          if (q.OPCODE == "ERROR") {
            alert(q.message);
          } else {
            this.quote = q;

            if (!this.modalObj._isShown) {
              this.modalObj.show();
            }
          }
          this.isQuoting = false;
        });
      }
    },
    paid() {
      this.affiliateIsPaid = true;
    },
    affiliateMarkedAsPaid() {
      this.affiliateIsPaid = false;
    },
  },
  mounted() {
    this.modalObj = new bs.Modal(document.getElementById("checkout-modal"));
  },
});
